import type { CSSProperties } from 'react';

/**
 * The one style every section heading on the homepage uses.
 *
 * Nine headings had drifted into three sizes (36 / 48 / 52px) and two cases,
 * so the page read as several designs stacked rather than one. The all-caps
 * condensed setting is the brand's signature, so that is the one that stayed
 * and the outliers were brought to it.
 *
 * The hero's h1 deliberately sits above this scale — see .hero-heading in
 * HeroSection. A page whose biggest heading is not its headline reads as if
 * the sections outrank the promise.
 */
export const SECTION_HEADING_CLASS = 'font-bold uppercase';

export const SECTION_HEADING_CLASS_FULL = `${SECTION_HEADING_CLASS} m-balance`;

/* 52px sat too close to the hero's 60px for the headline to outrank the
   sections it introduces. Dropping the ceiling to 48px while the hero rises to
   a fluid 68px restores a real step between the two. Line-height moves off a
   hard 1.0 — at three lines of condensed caps, 1.0 collides ascenders with the
   descenders above them. */
export const SECTION_HEADING_STYLE: CSSProperties = {
  fontFamily: "'Archivo Narrow', 'Roboto Condensed', sans-serif",
  fontSize: 'clamp(30px, 3.8vw, 48px)',
  color: 'var(--m-ink)',
  letterSpacing: '0.02em',
  lineHeight: 1.05,
  textWrap: 'balance',
};
